import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TOPIC_TEASER_BOX_CONVERTER_TOKEN, TopicTeaserBoxConverter } from './topic-teaser-box.component.converter'
import {
  TOPIC_TEASER_BOX_ITEM_CONVERTER_TOKEN, TopicTeaserBoxItemConverter
} from './topic-teaser-box-item/topic-teaser-box-item.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        topicTeaserBoxFeature: {
          module: () => import('./topic-teaser-box.module').then((m) => m.TopicTeaserBoxModule),
          cmsComponents: ['teaserboxes'],
        },
      }
    }),
    {
      provide: TOPIC_TEASER_BOX_CONVERTER_TOKEN,
      useClass: TopicTeaserBoxConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserboxes: TOPIC_TEASER_BOX_CONVERTER_TOKEN
      },
      multi: true
    },
    {
      provide: TOPIC_TEASER_BOX_ITEM_CONVERTER_TOKEN,
      useClass: TopicTeaserBoxItemConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        teaserbox: TOPIC_TEASER_BOX_ITEM_CONVERTER_TOKEN
      },
      multi: true
    }

  ]
})
export class TopicTeaserBoxFeatureModule {}
